<template>
  <div class="main-contaienr">
    <div class="left">
      <!-- 应急事件统计 -->
      <div class="urgent1 leftChild">
        <cus-border title="应急事件统计" ref="blya1">
          <div class="urgent-group">
            <div
              class="urgent-item"
              v-for="(item, index) in urgentList"
              :key="index"
            >
              <urgent-item :item="item"></urgent-item>
            </div>
          </div>
        </cus-border>
      </div>
      <!-- 事件发生趋势 -->
      <div class="ticket1 leftChild">
        <cus-border title="事件发生趋势" ref="blya3">
          <event-occurrence></event-occurrence>
        </cus-border>
      </div>
      <!-- 事件列表 -->
      <div class="video bottomChild">
        <cus-border title="事件列表" ref="blya5">
          <incident-list></incident-list>
        </cus-border>
      </div>
    </div>
    <div class="center">
      占位
      <!-- <div class="center-map">
        <drawn-map></drawn-map>
      </div> -->
    </div>
    <div class="right">
      <!-- 事件类型分布 -->
      <div class="urgent rightChild">
        <cus-border title="事件类型分布" ref="blya2">
          <event-type></event-type>
        </cus-border>
      </div>
      <!-- 事件级别分布 -->
      <div class="ticket rightChild">
        <cus-border title="事件级别分布" ref="blya4">
          <event-level></event-level>
        </cus-border>
      </div>
    </div>
  </div>
</template>
<script>
  // 导入地图
  // import drawnMap from '@/components/drawn-map/drawn-map'
  //音频播放
  // //事件列表
  import incidentList from './components/list'
  // //事件发生趋势
  import eventOccurrence from './components/event-occurrence'
  // //事件类型分布
  import eventType from './components/event-type'
  // //事件级别分布
  import eventLevel from './components/event-level'

  // 导入应急事件统计
  import urgentItem from '../main/components/urgent-item'

  export default {
    components: {
      // drawnMap,
      incidentList,
      urgentItem,
      eventOccurrence,
      eventType,
      eventLevel,
    },
    data() {
      return {
        // 今日统计
        statisticsList: [
          {
            num: '345',
            name: '已停车次',
            fileName: 'statistics1',
            iconWidth: '1.8975vw',
          },
          {
            num: '143,50',
            name: '入园人数',
            fileName: 'statistics2',
            iconWidth: '1.5625vw',
          },
          {
            num: '124,540',
            name: '售票数量',
            fileName: 'statistics3',
            iconWidth: '1.5625vw',
          },
        ],
        // 今日检票
        ticketList: {
          cake: [
            {
              total: 874,
              number: 586,
              name: '线下已检票',
              color: ['#4598FD', '#0D76F9'],
              dashed: '#02FFA3',
            },
            {
              total: 705,
              number: 254,
              name: '线上已检票',
              color: ['#24EF88', '#03B55B'],
              dashed: '#FFCC02',
            },
          ],
          progress: [
            {
              name: '应入园线下票',
              total: 12000,
              number: 9560,
              color: ['#0A3124', '#02FFA3'],
            },
            {
              name: '应入园线上票',
              total: 1000,
              number: 560,
              color: ['#123C40', '#00F6FF'],
            },
          ],
        },
        // 应急事件统计
        urgentList: [
          {
            num: '46',
            name: '已处理事件',
            fileName: 'urgent1',
          },
          {
            num: '29',
            name: '未处理事件',
            fileName: 'urgent2',
          },
          {
            num: '19',
            name: '本月事件',
            fileName: 'urgent3',
          },
          {
            num: '945',
            name: '本年事件',
            fileName: 'urgent4',
          },
        ],
        // 停车场使用情况
        parking: {
          ratioNumber: 1520,
          ratioTotal: 3424,
          xData: [
            '01时',
            '02时',
            '03时',
            '04时',
            '05时',
            '06时',
            '07时',
            '08时',
          ],
          val: [220, 55, 191, 10, 150, 330, 110, 125],
        },
        // wifi综合统计
        wifi: {
          total: 775,
          number: 248,
        },
        a1Wit: 0,
        a2Wit: 0,
      }
    },
    beforeDestroy() {
      this.$animejs.remove(['.leftChild', '.rightChild', '.bottomChild'])
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        let anime = this.$animejs
        anime({
          targets: '.leftChild',
          translateX: [-600, 0],
          scale: [0, 1],
          easing: 'easeInOutSine',
          delay: anime.stagger(200),
        })
        anime({
          targets: '.rightChild',
          translateX: [600, 0],
          scale: [0, 1],
          easing: 'easeInOutSine',
          delay: anime.stagger(200),
        })
        anime({
          targets: '.bottomChild',
          translateY: [200, 0],
          scale: [0, 1],
          easing: 'easeInOutSine',
          delay: 200,
        })
        // this.$animejs({
        //   targets: '.svg-container',
        //   boxShadow: [
        //     {
        //       value: '0 0 6px 6px rgba(255,255,255,.2)',
        //       easing: 'easeOutSine',
        //       duration: 1000,
        //     },
        //     {
        //       value: '0 0 0 0 rgba(255,255,255,.2)',
        //       easing: 'easeInOutQuad',
        //       duration: 1500,
        //     },
        //   ],
        //   delay: this.$animejs.stagger(100, { grid: [14, 5], from: 'center' }),
        // })
        //因为有多个相同组件时，浏览器窗口监听事件会被覆盖，所以通过在父级监听浏览器变化向子级触发事件，子组件ref必须是唯一。
        window.onresize = () => {
          // this.$nextTick(() => {})
          this.$refs.blya1.init()
          this.$refs.blya2.init()
          this.$refs.blya3.init()
          this.$refs.blya4.init()
          this.$refs.blya5.init()
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .main-contaienr {
    position: relative;
    display: flex;
    .center-map {
      position: absolute;
      height: 100vh;
      width: 100vw;
      left: -1.0416vw;
      top: 0;
    }
    .left,
    .right {
      width: 23.59375vw;
      position: relative;
      z-index: 3;
      // 今日检票
      .ticket {
        height: 25vh;
        margin: 1.5vh 0;
      }
      //事件发生趋势
      .ticket1 {
        height: 28vh;
        margin: 1.5vh 0;
      }
      // 事件列表
      .video {
        width: 97.985vw;
        height: 33.5vh;
        opacity: 0.9;
      }

      .urgent {
        height: 24vh;
        .urgent-group {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .urgent-item {
            width: 23%;
          }
        }
      }
      // 应急事件统计
      .urgent1 {
        height: 21vh;
        .urgent-group {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .urgent-item {
            width: 23%;
          }
        }
      }
    }
    .center {
      flex-grow: 1;
      color: transparent;
    }
  }
</style>
